<template>
    <span class="ai-refine d-inline-block">
        <button type="button" class="btn btn-sm btn-outline-info ai-refine-btn"
            :disabled="loading" @click="refine"
            :title="$t('Improve spelling, grammar and clarity with AI')">
            <app-icon name="zap" /> {{ loading ? $t('Improving…') : $t('Improve with AI') }}
        </button>

        <div v-if="suggestion !== null" class="ai-refine-panel card mt-2 mb-2">
            <div class="card-body p-2">
                <small class="text-muted d-block mb-1">
                    {{ $t('AI suggestion') }} — {{ $t('review before using') }}:
                </small>
                <div class="ai-suggestion mb-2">{{ suggestion }}</div>
                <button type="button" class="btn btn-sm btn-primary mr-2" @click="accept">{{ $t('Use this') }}</button>
                <button type="button" class="btn btn-sm btn-link text-muted" @click="discard">{{ $t('Discard') }}</button>
            </div>
        </div>
    </span>
</template>

<script>
import { axiosPost } from "../../../../../common/Helper/AxiosHelper";
import { AI_REFINE_TEXT } from "../../../../Config/ApiUrl-CP";

export default {
    name: "ai-refine-button",
    props: {
        // Current text of the field to refine.
        text: { type: String, default: "" },
        // A short label passed to the AI as context (e.g. "Diagnosis").
        context: { type: String, default: "clinical note" },
    },
    data() {
        return { loading: false, suggestion: null };
    },
    methods: {
        refine() {
            const value = (this.text || "").trim();
            if (!value) {
                this.$toastr.e(this.$t("Nothing to improve."));
                return;
            }
            this.loading = true;
            this.suggestion = null;
            axiosPost(AI_REFINE_TEXT, { text: value, context: this.context })
                .then((res) => {
                    this.suggestion = (res.data && res.data.refined) || "";
                })
                .catch((e) => {
                    const msg = (e.response && e.response.data && e.response.data.message)
                        || this.$t("AI request failed.");
                    this.$toastr.e(msg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        accept() {
            this.$emit("apply", this.suggestion);
            this.suggestion = null;
        },
        discard() {
            this.suggestion = null;
        },
    },
};
</script>

<style scoped>
.ai-suggestion {
    white-space: pre-line;
    font-size: 13px;
    background: #f6fbff;
    border: 1px solid #cfe8f7;
    border-radius: 4px;
    padding: 8px;
}
.ai-refine-panel { border-color: #cfe8f7; }
</style>
